import stylesheet from './searchspring-trending-searches.component.scss?as=stylesheet';
import {html, nothing, LitElement} from 'lit';
import TrendingSearches from 'custom-extensions/searchspring/lib/services/trendingsearches-service';

export default class SearchspringTrendingSearches extends LitElement {

	static get properties () {
		return {
			_trending: {
				type: Array
			},
			title: {
				type: String
			}
		};
	}

	static get styles () {
		return [stylesheet];
	}

	constructor () {
		super();

		this._trending = [];
		this.title = '';
		this.SearchUrl = mivaJS.Search_Url;
	}

	connectedCallback () {
		super.connectedCallback();
		this.getTrending();
	}

	async getTrending () {
		const trendingSearches = new TrendingSearches();
		const trendingResults = await trendingSearches.getTrending();

		this._trending = [];

		if (trendingResults) {
			for (const trendingResult of trendingResults) {
				this._trending.push(trendingResult.searchQuery);
			}
		}
	}

	renderTrendingItems () {
		return this._trending?.map((trendingItem) => {
			return html`
				<li class="x-trending-searches__list-item">
					<a class="x-trending-searches__list-item-link" href="${this.SearchUrl}Search=${trendingItem}">
						<span class="x-trending-searches__list-item-icon u-icon-search" aria-hidden="true"></span>
						<span class="x-trending-searches__list-item-text">${trendingItem}</span>
					</a>
				</li>
			`;
		});
	}

	render () {
		if (!this._trending?.length) {
			return nothing;
		}

		return html`
			<div class="x-trending-searches">
				${this.title ? html`<p class="x-trending-searches__title">${this.title}</p>` : nothing}
				<ul class="x-trending-searches__list">
					${this.renderTrendingItems()}
				</ul>
			</div>
		`;
	}
}

window.customElements.define('x-ss-trending-searches', SearchspringTrendingSearches);
